/**
 * BooleanIcon/index.js
 * desc: boolean data-type icon
 * note: type icon via IconButton; defaults its tooltip + accessible name to the
 *       data-type title. Exported as both the default and a named (ref-able) component.
 */
'use strict';

import IconButton from '../IconButton';
import { translate } from '../../../utilities/localization';


export const BooleanIcon = ({ tooltip, ref, ...props }) => {
    return (
        <IconButton ref={ ref } baseClassName="boolean icon" label={ tooltip || translate('icons.boolean.tooltip.text') } tooltip={ tooltip } { ...props }>
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 96 960 960"><path d="M378 810 154 586l43-43 181 181 384-384 43 43-427 427Z"/></svg>
        </IconButton>
    );
};


export default BooleanIcon;
